import { render, staticRenderFns } from "./YogoButton.vue?vue&type=template&id=b290ecc0&scoped=true&"
import script from "./YogoButton.vue?vue&type=script&lang=js&"
export * from "./YogoButton.vue?vue&type=script&lang=js&"
import style0 from "./YogoButton.vue?vue&type=style&index=0&id=b290ecc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b290ecc0",
  null
  
)

export default component.exports